import { CommonModule, DOCUMENT, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import { Component, PLATFORM_ID, Inject, Input, ViewChild, ElementRef, ChangeDetectorRef, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { SlideshowBankComponent } from '@template/green/parts/slideshow-bank/slideshow-bank.component';
import { DataService } from '@componentpath/services/data.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { EncodeUriPipe, OrderByPipe, RemoveDashPipe, SlugNamePipe } from '@componentpath/pipes/slug-name.pipe';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { AuthService } from '@componentpath/services/auth.service';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  imports: [
    CommonModule,
    SlideshowBankComponent,
    MatExpansionModule,
    MatIconModule,
    SlugNamePipe,
    NgOptimizedImage,
    EncodeUriPipe,
    RouterModule,
    RemoveDashPipe,
    OrderByPipe
  ],
})
export class FooterComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('cardTitleFooter') cardTitleFooter!: ElementRef;
  @ViewChild('cardTitleTextFooter') cardTitleTextFooter!: ElementRef;
  @ViewChild('cardTitleFooterSmall') cardTitleFooterSmall!: ElementRef;
  @ViewChild('cardTitleTextFooterSmall') cardTitleTextFooterSmall!: ElementRef;

  subscription: Subscription = new Subscription();

  @Input() data: any;
  panelOpenState: boolean = false;
  bankList: Array<any> = [];
  providerList: Array<any> = [];
  footerJSONData: Array<any> = [];
  footerHtml: any = {};
  websiteJSONData: any = this.dataService.websiteJSONData;
  currentScreenSize: string = '';
  cardTitleWidth: any = 0;
  cardTitleTextWidth: any = 0;
  cardTitleSmallWidth: any = 0;
  cardTitleTextSmallWidth: any = 0;
  showReferral: boolean = true;
  addMorePadding: boolean = true;
  currentYear = new Date().getFullYear();
  sourceAPK: any = 'desktop';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private doc: Document,
    private auth: AuthService,
    private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private cookie: SsrCookieService
  ) {
    if (cookie.get('source')) {
      this.sourceAPK = cookie.get('source');
    }
    this.bankList = this.dataService.bankRegisterJSONData['records'];
    // console.log(this.bankList)
    this.checkScreen();
  }

  checkScreen() {
    let displayNameMap = new Map([
      [Breakpoints.XSmall, 'xSmall'],
      ["(min-width: 600px) and (max-width: 799.98px)", 'smallOne'],
      ["(min-width: 800px) and (max-width: 959.98px)", 'smallTwo'],
      ["(min-width: 960px) and (max-width: 1365.98px)", 'customTablet'],
    ]);
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      "(min-width: 600px) and (max-width: 799.98px)",
      "(min-width: 800px) and (max-width: 959.98px)",
      "(min-width: 960px) and (max-width: 1365.98px)",
      "(min-width: 1366px)"
    ]).subscribe(result => {
      // console.log(result)
      for (const query of Object.keys(result.breakpoints)) {
        if (result.breakpoints[query]) {
          this.currentScreenSize = displayNameMap.get(query) ?? 'desktop';
        }
      }
    });
  }

  extractTitleAndBody(html: string): { title: string; body: string } {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const firstHeader = doc.querySelector('h1, h2, h3, h4, h5, h6');
    let title = '';
    if (firstHeader) {
      title = firstHeader.outerHTML || '';
      firstHeader.remove();
    }

    const body = doc.body.innerHTML;

    return { title, body };
  }

  subscriptionData() {
    this.subscription.add(
      this.auth.getLoginStatus.subscribe({
        next: (v) => {
          if (v && this.auth.userProfileData !== null) {
            // console.log(this.dataService.referralRuleJSONData);
            // console.log(this.auth.userProfileData);
            for (const [key, value] of Object.entries(this.dataService.referralRuleJSONData)) {
              let val = value as any
              if (this.auth.userProfileData['group'] === val.group) {
                this.showReferral = true;
                break;
              } else {
                this.showReferral = false;
              }
            }
          }
          if (v === false) {
            if ((this.dataService.referralRuleJSONData as Array<any>).length === 0) {
              // console.log("empty")
              this.showReferral = false;
            }
          }
        },
      })
    );
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['source']) {
        this.sourceAPK = (params['source']).toLowerCase();
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      this.subscriptionData();
      this.bankList = this.dataService.bankRegisterJSONData['records'];
      this.providerList = this.dataService.providerJSONData['records'];
      this.footerJSONData = this.dataService.footerJSONData['records'];
      if (this.activatedRoute.snapshot.url.length === 0 || this.activatedRoute.snapshot.url[0].path === 'game' || this.activatedRoute.snapshot.url[0].path === 'provider' || this.activatedRoute.snapshot.url[0].path === 'real-money' || this.activatedRoute.snapshot.url[0].path === 'search'){
        this.addMorePadding = true;
      } else {
        this.addMorePadding = false;
      }

      // let filterType = this.footerJSONData.filter((x: any) => (x.type === "HOMEPAGE"));
      let filterType = this.websiteJSONData.scripts.footer;
      // console.log(filterType)
      if(filterType){
        this.footerHtml = this.extractTitleAndBody(filterType);
      } else{
        this.footerHtml.title = "<h1>Situs Slot terbaru dan terpercaya, deposit pulsa</h1>";
        this.footerHtml.body = "<p>Situs Slot terbaru dan terpercaya, mainkan akun demo pragmatic, tanpa deposit dapat uang asli, deposit pulsa dan dapatkan bonus new member. Menang Maxwin!</p>\r\n<p>Akun demo memberikan kesempatan untuk bermain slot secara gratis tanpa perlu melakukan deposit, sehingga pengalaman bermain slot pragmatic menjadi lebih menyenangkan. Dengan akun demo kami, Anda dapat dengan mudah mengakses berbagai pilihan permainan gacor maxwin dari pragmatic play hanya di satu situs. Saat ini, akun demo slot pragmatic play dikenal sebagai penyedia yang memudahkan para penggemar permainan slot online untuk meraih maxwin.</p>\r\n<p>Segera daftarkan diri Anda sekarang untuk mendapatkan peluang bermain demo slot Olympus 1000, sehingga Anda dapat terus berlatih bermain Pragmatic Play tanpa perlu melakukan deposit. Pastikan Anda selalu memiliki akses untuk bermain akun demo slot kami 1000 terbaru bagi para penggemar slot Olympus di situs kami.</p>\r\n<p>Rasakan pengalaman bermain slot Olympus Zeus 1000 secara nyata. Pilihan game gacor maxwin terbaru siap dimainkan kapan saja. Gunakan platform akun demo kami untuk mencoba.</p>\r\n<p>Demo slot Olympus 1000 tanpa biaya dan tanpa perlu deposit adalah kesempatan emas bagi pengunjung pragmatic play yang ingin mencoba permainan terbaru dengan cara gratis. Akun demo kami memberikan kredit virtual senilai 100.000, yang akan terisi secara otomatis di akun demo slot Olympus 1000. Dengan begitu, para pengunjung pragmatic play dapat menikmati permainan demo slot Zeus 1000 tanpa khawatir, karena mereka bisa bermain tanpa batasan waktu.</p>\r\n<p>Maka, permainan slot gacor dari akun demo kami 1000 menjadi peluang untuk menikmati permainan Pragmatic Play lebih lama sesuai keinginan pemain. Ayo, coba pengalaman bermain tanpa deposit di situs akun demo kami. Anda bisa mengakses 1000 pilihan slot demo terbaru hanya dengan satu akun demo. Selain itu, Anda juga dapat mendaftar akun demo slot gacor secara gratis tanpa deposit langsung melalui halaman situs ini.</p>\r\n<p>Ratusan slot demo gratis menanti anda seperti akun demo slot pg, demo olimpus, demo slot pg soft mahjong 2, demo kakek zeus, demo slot gratis, demo slot max win, demo slot zeus maxwin.</p>"
        
      }
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        // console.log(this.doc.querySelector("#cardTitleFooter")?.clientWidth)
        // console.log(this.cardTitleFooter.nativeElement.clientWidth)
        if (this.cardTitleFooter) {
          this.cardTitleWidth = this.doc.querySelector("#cardTitleFooter")?.clientWidth;
          this.cdr.detectChanges();
          // console.log(this.cardTitleWidth)
        }
        if (this.cardTitleTextFooter) {
          this.cardTitleTextWidth = this.cardTitleTextFooter.nativeElement.clientWidth;
          this.cdr.detectChanges();
          // console.log(this.cardTitleTextWidth)
        }
        if (this.cardTitleFooterSmall) {
          this.cardTitleSmallWidth = this.doc.querySelector("#cardTitleFooterSmall")?.clientWidth;
          this.cdr.detectChanges();
          // console.log(this.cardTitleWidth)
        }
        if (this.cardTitleTextFooterSmall) {
          this.cardTitleTextSmallWidth = this.cardTitleTextFooterSmall.nativeElement.clientWidth;
          this.cdr.detectChanges();
          // console.log(this.cardTitleTextWidth)
        }
      }, 1000);
    }

  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.subscription.unsubscribe();
      // window.removeEventListener('scroll', this.scroll, true);
    }
  }
}
